import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import Editor from 'locize-editor'
import moment from 'moment'

import { store } from 'store'
import { loadLanguages } from 'store/entities/localSettings/actions'
import { fetchOrganizationSettingsByDomain } from 'store/entities/organizationSettings/actions'
import { getOrganizationLanguage } from 'store/request.js'

import { locizeApiKey, locizeProjectId } from 'app/config'

const locizeOptions = {
  projectId: locizeProjectId,
  apiKey: locizeApiKey,
  referenceLng: 'en',
}

i18n.on('loaded', function(loaded) {
  store.dispatch(loadLanguages(loaded))
})

export const i18Init = () => {
  getOrganizationLanguage().then(orgSettingsByDomain => {
    store.dispatch(fetchOrganizationSettingsByDomain.success(orgSettingsByDomain))
    const language = orgSettingsByDomain.language
    i18n
      .use(Backend)
      .use(Editor)
      .use(initReactI18next)
      .init({
        lng: language,
        fallbackLng: 'en',
        ns: ['common', 'login', 'user', 'admin'],
        defaultNS: 'common',
        saveMissing: false,
        initImmediate: false,
        interpolation: {
          escapeValue: false,
        },
        backend: locizeOptions,
        editor: {
          ...locizeOptions,
          onEditorSaved: async (lng, ns) => {
            await i18n.reloadResources(lng, ns)
            i18n.emit('editorSaved')
          },
        },
        react: {
          useSuspense: false,
          bindI18n: 'languageChanged editorSaved',
        },
        keySeparator: '::',
      })
      .then(() => {
        i18n.loadLanguages(language)
        moment.locale(language === 'zh' ? 'zh-cn' : language)
      })
  })
}
